import React from 'react'

const Heading = () => {
  return (
    <div >
      <h2 className="section_title">My Services</h2>
      <h2 className="section__subtitle">What I Offer</h2>

    </div>
  )
}

export default Heading